(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-featured-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.s-featured-products').forEach(section => {
    const tabs = section.querySelectorAll('.s-featured-products__tab');
    const slides = section.querySelectorAll('.s-featured-products__slide');
    const controlsDesktop = section.querySelector('.s-featured-products__controls--desktop');

    // show/hide arrows depending on number of visible slides
    const updateControlsVisibility = () => {
      if (!controlsDesktop) return;
      const visibleSlides = Array.from(slides).filter(
        slide => slide.style.display !== 'none'
      );
      controlsDesktop.style.display = visibleSlides.length > 4 ? 'flex' : 'none';
    };

    const activateTab = (handle) => {
      // update tab states
      tabs.forEach(t => {
        const active = t.dataset.handle === handle;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active);
      });

      // show/hide slides by handle
      slides.forEach(slide => {
        slide.style.display = slide.dataset.collection === handle ? '' : 'none';
      });

      updateControlsVisibility();
    };

    if (window.FMSlider && typeof window.FMSlider.init === 'function') {
      setTimeout(() => window.FMSlider.init(section.querySelector('[data-fm-slider]')), 50);
    }


    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const handle = tab.dataset.handle;
        if (!handle) return;
        activateTab(handle);
      });
    });

    // initialize with first active
    const firstActive = tabs[0];
    if (firstActive) activateTab(firstActive.dataset.handle);
  });
});

  } catch(e) { console.error(e); }
})();
})();
